/** @jsx jsx */
import React from "react";
import { graphql } from "gatsby";
import { jsx, Box, Flex, Heading, Paragraph, Container } from "theme-ui";
import { GatsbyImage } from "gatsby-plugin-image";
import { BgImage } from "gbimage-bridge";
import Action from "../../shared/Action";
import ContentfulRichText from "../../shared/ContentfulRichText";
import "./ContributorCardsSection.css";

export const query = graphql`
  fragment ContentfulContributorCardsSectionFragment on ContentfulContributorCardsSection {
    heading
    subHeading
    contributors { 
      ... on ContentfulContributorCard {
        contributorName
        heading
        image {
          gatsbyImageData
        }
        content {
          raw
        }
      }
    }
  }
`;

const ContributorCardsSection = ({ sectionContent }) => {
  const { heading, subHeading, contributors } = sectionContent;
  return (
    <Flex sx={{ backgroundColor: "var(--theme-ui-colors-lightGrey)", justifyContent: "center" }}>
      <Container >
        <Flex sx={{ alignItems: "center", flexDirection: "column" }}>
          <Heading as="h2" variant="extraBold" marginBottom="32px" marginTop="45px">
            {heading}
          </Heading>
          <Heading as="h4" variant="extraBold" marginBottom="32px">
            {subHeading}
          </Heading>
          {contributors.map((contributor) => (
            <Flex sx={{ justifyContent: "center", flexDirection: ["column", "row"] }} className="contributor-card">
              <Box className="contributor-card-image-container">
                <Box className="contributor-card-image">
                  <GatsbyImage
                    image={contributor.image.gatsbyImageData}
                  />
                </Box>
                <Heading as="h6" variant="extraBold" marginBottom="32px" marginTop="45px">
                  {contributor.contributorName}
                </Heading>
              </Box>
              <Box className="contributor-card-text" sx={{ alignItems: ["center", "unset"]}}>
                <Heading as="h6" variant="extraBold" marginBottom="32px" marginTop="45px">
                  {contributor.heading}
                </Heading>
                <ContentfulRichText richText={contributor.content} />
              </Box>
            </Flex>
          ))}
        </Flex>
      </Container>
    </Flex>
  );
};

export default ContributorCardsSection;
